import ImageMatchTemplate from "./ImageMatchTemplate";
import CleanProfessionalTemplate from "./CleanProfessionalTemplate";
import SimpleProfessionalTemplate from "./SimpleProfessionalTemplate";
import ProfessionalBulletTemplate from "./ProfessionalBulletTemplate";
import ModernProfessionalTemplate from "./ModernProfessionalTemplate";
// 1. Naya template import karein
import EnhancvTemplate from "./EnhancvTemplate";
import ExecutiveTemplate from "./ExecutiveTemplate";
import TealSidebarTemplate from "./TealSidebarTemplate";

export const templates = [
  {
    id: "enhancv-style", // Unique ID
    label: "Enhancv Style",
    description:
      "Dark blue header with dual-column layout and profile placeholder",
    component: EnhancvTemplate,
  },
  {
    id: "image-match",
    label: "Image Match",
    description: "Two‑column professional with dark sidebar",
    component: ImageMatchTemplate,
  },
  {
    id: "clean-professional",
    label: "Clean Professional",
    description: "Minimalist layout with top header and two columns",
    component: CleanProfessionalTemplate,
  },
  {
    id: "simple-professional",
    label: "Simple Professional",
    description: "Clean two-column with numbered achievements",
    component: SimpleProfessionalTemplate,
  },
  {
    id: "professional-bullet",
    label: "Professional Bullet",
    description: "Two-column with bullet achievements, skills, courses",
    component: ProfessionalBulletTemplate,
  },
  {
    id: "modern-professional",
    label: "Modern Professional",
    description: "Two-column with bold achievements, skills, training",
    component: ModernProfessionalTemplate,
  },
  {
    id: "executive-minimalist",
    label: "Executive Minimalist",
    description: "Classic centered layout, high ATS readability",
    component: ExecutiveTemplate,
  },
  {
    id: "teal-sidebar",
    label: "Teal Professional",
    description: "Solid teal sidebar with profile placeholder",
    component: TealSidebarTemplate,
  },
];
